import React from "react"

import { useNavigate } from "react-router-dom"

import { FixedTopRightActionElement } from "@front-shared/elements/fixedTopRightAction.element.tsx"
import { PrimaryText } from "@front-shared/elements/primaryText.element.tsx"

import { AuthHelper } from "../../helpers/auth.helper"
import { useAppDispatch } from "../../store/appDispatch.hook.ts"

import lockImage from "@front-shared/assets/images/icons/lock.svg"
import logo from "@front-shared/assets/images/logo-small.svg"

export const PracticeMissingBAALockComponent: React.FunctionComponent = () => {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    return (
        <div className="fixed z-1070 let-0 top-0 bg-brand-offWhite w-screen h-screen pt-[40px] px-[40px]">
            <div className="pb-[120px]">
                <img src={logo} alt="Nirvana" />
            </div>

            <div className="w-[600px] mx-auto flex flex-col gap-[32px]">
                <img src={lockImage} alt="Nirvana" title="Nirvana" width={60} />

                <PrimaryText typography="h1">
                    Your practice owner needs to sign the Business Associate
                    Agreement
                </PrimaryText>

                <PrimaryText typography="buttonText">
                    You cannot access Nirvana until your practice owner has
                    signed the BAA.
                </PrimaryText>
            </div>

            {/*Logout*/}
            <FixedTopRightActionElement
                ctaLabel="Log out"
                ctaAction={() => {
                    AuthHelper.logout(dispatch, undefined, navigate)
                }}
            />
        </div>
    )
}
